import { useEffect } from "react";
import { GoabDivider, GoabButtonGroup } from "@abgov/react-components";

import {
  PaymentInfoSection,
  EmailSection,
  AccountTypeSection,
  PersonalInformationSection,
  MailingAddressSection,
  PhysicalResidenceSection,
  TemporaryContactInformationSection,
  FirstNationsSection,
  FamilyMembersSection,
  GenerationInformationSection,
  PrimaryContactInformationSection,
  EventSection,
  FormValidationErrors,
} from "./components";
import { SubmitButton, RandomizeAndResetButton } from "./components/actions";
import { useAppDispatch, setApplication } from "../store";
import { useGenerationForm } from "./hooks";
import { SessionAndDataContext } from "./context";

import { generateInitialUserApplicationData } from "../../../MPP-Common-SPA/utils/generator";

export const GenerationForm = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { application, form } = useGenerationForm();

  // Initialize application
  useEffect(() => {
    if (!application) {
      const initialApplication = generateInitialUserApplicationData();
      dispatch(setApplication(initialApplication));
    }
  }, [application, dispatch]);

  // Early return if application hasn't been created yet.
  if (!application) {
    return <></>;
  }

  return (
    <>
      <SessionAndDataContext>
        <form onSubmit={form.handleSubmit}>
          <EmailSection />
          {/* Appears that ArcGIS token is based on the environment, will need to update arcGIS from ProgramEvents 
          and so cannot update evacuation location coordinates from polygon based on program/event selection. */}
          {/* <ProgramSection></ProgramSection> */}
          <EventSection />
          <AccountTypeSection />
          <PersonalInformationSection />
          <MailingAddressSection />
          <PrimaryContactInformationSection />
          <PhysicalResidenceSection />
          <TemporaryContactInformationSection />
          <FirstNationsSection />
          <FamilyMembersSection />

          {/* Payment info section is only shown when not a basic account. */}
          {form.values.verificationStatus !== 1 && <PaymentInfoSection />}

          <GoabButtonGroup alignment="start">
            <SubmitButton />
            <RandomizeAndResetButton />
          </GoabButtonGroup>
        </form>

        <FormValidationErrors />

        {/* Show application code after submission. */}
        {application.uniqueApplicationCode !== "" && (
          <>
            <GoabDivider />
            <GenerationInformationSection />
          </>
        )}
      </SessionAndDataContext>
    </>
  );
};
